import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/reports/')({
	loader: async () => {
		throw redirect({ to: '/reports/access-logs' });
	},
	component: () => null,
});
